import * as React from "react";
import {
	BillOfMaterialsPreviewAsset,
	BillOfMaterialsPreviewItemOfMaterial,
	BillOfMaterialsPreviewItems
} from "../../../../model/job/BillOfMaterialsPreviewItems";
import DataGrid from "../../../../hiberUiKit/src/organisms/DataGrid/DataGrid";
import ButtonPrimary from "../../../../hiberUiKit/src/atoms/Buttons/ButtonPrimary";
import DropDownWrapper from "../../../../hiberUiKit/src/molecules/DropDownWrapper/DropDownWrapper";
import DropDownList, {DropDownItem} from "../../../../hiberUiKit/src/molecules/DropDownList/DropDownList";
import IconWrapper from "../../../../hiberUiKit/src/atoms/Icon/IconWrapper";
import {Icon} from "../../../../hiberUiKit/src/atoms/Icon/Icon";
import {BomItem} from "../../../../model/job/BomItems";

interface ComponentProps {
	/**
	 * Bill of materials items divided by assets
	 */
	items: BillOfMaterialsPreviewItems;
	/**
	 * Indicates if is bom dispalyed
	 */
	isBom: boolean;
	/**
	 * Show add asset modal action
	 */
	onShowAddAssetModalClick: () => void;
	/**
	 * Remove asset action
	 */
	onRemoveAssetClick: (asset: BomItem) => void;
	/**
	 * Edit asset action
	 */
	onEditAssetClick: (asset: BomItem) => void;
	/**
	 * Edit asset action
	 */
	markAsHiberParts: (asset: BomItem) => void;
	/**
	 * Show add material modal action
	 */
	onShowAddMaterialModalClick: (asset: BomItem) => void;
	/**
	 * Remove material action
	 */
	onRemoveMaterialClick: (asset: BomItem, material: BillOfMaterialsPreviewItemOfMaterial) => void;
	/**
	 * If false, bom is read only.
	 */
	editable: boolean;
}

interface State {
	/**
	 * Indicates for each asset if its materials list is visible
	 */
	assetsDisplay: Array<boolean>;
	/**
	 * Asset menu dropdown visibility.
	 */
	assetMenuDropDownVisible: Array<boolean>;
	/**
	 * Asset menu dropdown items
	 */
	assetMenuItems: DropDownItem[]
}

export default class JobBillOfMaterialsDetailsTableView extends React.Component<ComponentProps, State> {

	constructor(props: ComponentProps) {
		super(props);
		this.state = {
			assetsDisplay: props.items.assets.map(() => true),
			assetMenuDropDownVisible: props.items.assets.map(() => false),
			assetMenuItems: [
				{id: AssetAction.ADD_MATERIAL, label: 'Add material'},
				{id: AssetAction.EDIT_ASSET, label: 'Edit asset', disabled: !props.editable}
			]
		};
		this.toggleAssetDisplay = this.toggleAssetDisplay.bind(this);
		this.getAssetPriceExplication = this.getAssetPriceExplication.bind(this);
		this.onAssetMenuItemSelect = this.onAssetMenuItemSelect.bind(this);
	}

	componentDidMount() {
		this.prepareMenuItems(this.props.items.assets.length);
	}

	componentWillReceiveProps(nextProps: ComponentProps) {
		if (this.props.items.assets.length !== nextProps.items.assets.length) {
			this.setState({
				assetsDisplay: nextProps.items.assets.map(() => true),
				assetMenuDropDownVisible: nextProps.items.assets.map(() => false)
			});
			this.prepareMenuItems(nextProps.items.assets.length);
		}
	}

	render() {
		const selfSourcedItemsMenuActions = [{
			id: AssetAction.MARK_AS_HIBER_PARTS,
			label: "Mark as hiber parts",
			disabled: !this.props.editable
		},
			{
				id: AssetAction.EDIT_ASSET,
				label: 'Edit asset',
				disabled: !this.props.editable
			}]
		const assets = this.props.items.assets.filter(a => !a.selfSourced)
		const selfSourcedAssets = this.props.items.assets.slice(assets.length);
		return (
			<div className="job-bill-of-materials_details-table">
				<DataGrid>
					<thead>
					<tr className="c-common-details_table-header-row t-uppercase">
						<th>
							Description
							{(this.props.isBom && this.props.editable) &&
							<ButtonPrimary label={'+'} onClick={this.props.onShowAddAssetModalClick}/>
							}
						</th>
						<th>Manufacturer</th>
						<th>Qty</th>
						<th>Merch.#</th>
						<th>Manuf.#</th>
						<th className={"t-right"}>Buy</th>
						<th className={"t-right"}>Sell</th>
						<th className={"t-right"}>Margin</th>
						<th className={"t-right"}>Rebate</th>
						<th className={"t-right"}>Profit</th>
					</tr>
					</thead>
					<tbody>
					{assets.filter(a => !a.selfSourced).map((item, index) => (
						<React.Fragment key={index}>
							<tr className="c-common-details_table-row">
								<td>
									<a className={"t-burgundy-color a-pointer"}
									   onClick={() => this.toggleAssetDisplay(index)}>
										<span
											className={`${this.state.assetsDisplay[index] ? "d-inline-block" : "d-none"}`}>
											<i className={"fa fa-fw fa-caret-down"}/>
										</span>
										<span
											className={`${this.state.assetsDisplay[index] ? "d-none" : "d-inline-block"}`}>
											<i className={"fa fa-fw fa-caret-up"}/>
										</span>
										<b className={"t-uppercase"}>{item.name}</b>
									</a>
									{this.props.isBom &&
									<div className="dropdown-wrapper-right">
										<IconWrapper icon={Icon.Overflow} variant={"burgundy"} size={18}
													 onClick={() => this.toggleAssetMenuDropDownVisible(index)}/>
										{this.state.assetMenuDropDownVisible[index] &&
										<DropDownWrapper width={165}
														 onOutsideClick={() => {this.toggleAssetMenuDropDownVisible(index)}}>
											<DropDownList items={this.state.assetMenuItems}
														  itemToId={(link: DropDownItem) => link.id}
														  itemToLabel={(link: DropDownItem) => link.label}
														  itemDisabled={(link: DropDownItem) => link.disabled}
														  onSelect={(dropdownItem: DropDownItem) => this.onAssetMenuItemSelect(
															  dropdownItem, item as BomItem, index)}/>
										</DropDownWrapper>}
									</div>}
								</td>
								<td>{item.manufacturerName.getOrElse('')}</td>
								<td>{item.quantity}</td>
								<td/>
								<td/>
								<td className={"price-cell"}>
									{item.buy.map(buy => buy.format()).getOrElse('-')}
									{item.buy.isDefined &&
									<div className={"t-blue-variant-color"}>
										{this.getAssetPriceExplication(item)}
									</div>}
								</td>
								<td className={"price-cell"}><b>{item.sell.format()}</b></td>
								<td className={"price-cell"}><b>{item.margin.format()}</b></td>
								<td className={"price-cell"}><b>{item.rebate.format()}</b></td>
								<td className={"price-cell"}>
									<b>{item.profit.map(profit => profit.format()).getOrElse('-')}</b>
									{item.profitInPercentage.isDefined && <span style={{marginLeft: "8px"}}>
										{item.profitInPercentage.get > 0 &&
										<b className={"t-green-color"}>+{item.profitInPercentage.get}%</b>}
										{item.profitInPercentage.get < 0 &&
										<b className={"has-error"}>-{item.profitInPercentage.get}%</b>}
									</span>}
								</td>
							</tr>
							{this.state.assetsDisplay[index] && item.materials.map((material, mIndex) => (
								<tr className={"c-common-details_table-row is-details-row"} key={mIndex}>
									<td className={"t-uppercase action-on-hover"}>
										{material.description}
										{this.props.isBom &&
										<IconWrapper icon={Icon.X}
													 size={16}
													 variant={'burgundy'}
													 onClick={() => this.props.onRemoveMaterialClick(item as BomItem, material)}/>
										}
									</td>
									<td/>
									<td>{item.quantity * material.quantity}</td>
									<td>{material.codeAtMerchant.orNull}</td>
									<td>{material.codeAtManufacturer.orNull}</td>
									<td className={"price-cell"}>
										{material.buy.map(buy => buy.format()).getOrElse('-')}
									</td>
									<td/>
									<td/>
									<td/>
									<td/>
								</tr>
							))}
							{!item.materials.length && this.state.assetsDisplay[index] &&
							<tr className={"c-common-details_table-row is-details-row red-row"}>
								<td colSpan={10}>No materials defined</td>
							</tr>}
						</React.Fragment>
					))}
					{!!selfSourcedAssets.length && <tr>
						<td colSpan={10} className={"not-included-in-bom-title"}>NOT INCLUDED IN BILL CALCULATION</td>
					</tr>}

					{selfSourcedAssets.map((item, index) =>
						<React.Fragment key={assets.length + index}>
							<tr className="c-common-details_table-row">
								<td>
									<a className={"t-burgundy-color a-pointer"}
									   onClick={() => this.toggleAssetDisplay(assets.length + index)}>
										<span
											className={`${this.state.assetsDisplay[assets.length + index] ?
												"d-inline-block" : "d-none"}`}>
											<i className={"fa fa-fw fa-caret-down"}/>
										</span>
										<span
											className={`${this.state.assetsDisplay[assets.length + index] ?
												"d-none" : "d-inline-block"}`}>
											<i className={"fa fa-fw fa-caret-up"}/>
										</span>
										<b className={"t-uppercase"}>{item.name}</b>
										<img src="/assets/img/icons/badge-selfsourced.svg"
											 className={"c-selfsourced-icon"}/>
									</a>
									{this.props.isBom &&
									<div className="dropdown-wrapper-right">
										<IconWrapper icon={Icon.Overflow} variant={"burgundy"} size={18}
													 onClick={() => this.toggleAssetMenuDropDownVisible(assets.length + index)}/>
										{this.state.assetMenuDropDownVisible[assets.length + index] &&
										<DropDownWrapper width={180}
														 onOutsideClick={() => {
															 this.toggleAssetMenuDropDownVisible(assets.length + index)
														 }}>
											<DropDownList items={selfSourcedItemsMenuActions}
														  itemToId={(link: DropDownItem) => link.id}
														  itemToLabel={(link: DropDownItem) => link.label}
														  itemDisabled={(link: DropDownItem) => link.disabled}
														  onSelect={(dropdownItem: DropDownItem) => this.onAssetMenuItemSelect(
															  dropdownItem, item as BomItem, assets.length + index)}/>
										</DropDownWrapper>}
									</div>}
								</td>
								<td/>
								<td>{item.quantity}</td>
								<td/>
								<td/>
								<td className={"price-cell"}>-</td>
								<td className={"price-cell"}><b>{item.sell.format()}</b></td>
								<td className={"price-cell"}>-</td>
								<td/>
								<td className={"price-cell"}>-</td>
							</tr>
							{!item.materials.length && this.state.assetsDisplay[assets.length + index] &&
							<tr className={"c-common-details_table-row is-details-row red-row"}>
								<td colSpan={10}>No materials defined</td>
							</tr>}
						</React.Fragment>
					)}
					</tbody>
				</DataGrid>
			</div>
		)
	}

	toggleAssetDisplay(assetIndex: number) {
		const display = this.state.assetsDisplay.map((disp, index) => index === assetIndex ? !disp : disp);
		this.setState({assetsDisplay: display});
	}

	toggleAssetMenuDropDownVisible(assetIndex: number) {
		const display = this.state.assetMenuDropDownVisible.map((disp, index) => index === assetIndex ? !disp : disp);
		this.setState({assetMenuDropDownVisible: display});
	}

	getAssetPriceExplication(item: BillOfMaterialsPreviewAsset): string {
		const arr: string[] = item.materials.filter(material => material.buyUnitPrice.isDefined).map(
			(material) => `${material.quantity * item.quantity} x ${material.buyUnitPrice.get.format()}`);
		return arr.join(" + ");
	}

	onAssetMenuItemSelect(item: DropDownItem, asset: BomItem, index: number) {
		this.toggleAssetMenuDropDownVisible(index);
		switch (item.id) {
			case AssetAction.REMOVE_ASSET:
				this.props.onRemoveAssetClick(asset);
				break;
			case AssetAction.EDIT_ASSET:
				this.props.onEditAssetClick(asset);
				break;
			case AssetAction.ADD_MATERIAL:
				this.props.onShowAddMaterialModalClick(asset);
				break;
			case AssetAction.MARK_AS_HIBER_PARTS:
				this.props.markAsHiberParts(asset);
				break;
		}
	}

	prepareMenuItems(size: number) {
		const hasRemoveAction = this.state.assetMenuItems.some(item => item.id === AssetAction.REMOVE_ASSET);
		if (size > 1 && !hasRemoveAction) {
			this.setState({
				assetMenuItems: this.state.assetMenuItems.concat(
					{id: AssetAction.REMOVE_ASSET, label: 'Remove asset', disabled: !this.props.editable})
			})
		}
		else if (size <= 1) {
			this.setState({
				assetMenuItems: [{id: AssetAction.ADD_MATERIAL, label: 'Add material'},
					{id: AssetAction.EDIT_ASSET, label: 'Edit asset', disabled: !this.props.editable}]
			})
		}
	}

}

export enum AssetAction {
	ADD_MATERIAL = 'ADD_MATERIAL',
	EDIT_ASSET = 'EDIT_ASSET',
	REMOVE_ASSET = 'REMOVE_ASSET',
	MARK_AS_HIBER_PARTS = "MARK_AS_HIBER_PARTS"
}
